module.exports = __webpack_public_path__ + "static/media/bp-top.3145e0d1.webp";